import {gql} from 'apollo-angular';


export interface Language {
  id?: string;
  description?: string;
}

export const language = gql`
    fragment language on LanguageModel {
        id
        description
    }
`;
